"use client";

import {
  researchIcons,
  type ResearchIconName,
} from "@/lib/icons/research-icons";

const SIZE_PX = {
  sm: 16,
  md: 22,
  lg: 28,
} as const;

type ResearchIconProps = {
  name: ResearchIconName;
  size?: keyof typeof SIZE_PX;
  className?: string;
};

/**
 * Рендерит Lucide напрямую на клиенте (без Astryx Icon),
 * чтобы не сериализовать function-компоненты через RSC-границу.
 */
export function ResearchIcon({
  name,
  size = "sm",
  className,
}: ResearchIconProps) {
  const Cmp = researchIcons[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={SIZE_PX[size]}
      strokeWidth={1.75}
      aria-hidden
      className={className ?? "shrink-0"}
    />
  );
}
